<template>
  <v-container>
    <v-row v-if="this.playerid === this.npc.PlayerId">
      <v-spacer></v-spacer>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn color="secondary" @click="EditNPC()" v-on="on">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Edit NPC</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            color="red darken-1"
            dark
            @click="deleteDialog = true"
            v-on="on"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Delete NPC</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col cols="6" md="4">
        <v-card shaped class="pa-1">
          <v-card-title class="justify-center primary--text">Name</v-card-title>

          <v-card-subtitle class="text-center">{{ npc.Name }}</v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="6" md="3">
        <v-card shaped class="pa-1">
          <v-card-title class="justify-center primary--text">Town</v-card-title>
          <v-card-subtitle class="text-center">{{
            npc.Town.Name
          }}</v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="6" md="2">
        <v-card shaped class="pa-1">
          <v-card-title class="justify-center primary--text">Age</v-card-title>
          <v-card-subtitle class="text-center">{{ npc.Age }}</v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="6" md="3">
        <v-card shaped class="pa-1">
          <v-card-title class="justify-center primary--text">Race</v-card-title>
          <v-card-subtitle class="text-center">{{
            npc.Race | capitalize
          }}</v-card-subtitle>
        </v-card>
      </v-col>

      <v-col cols="12" md="8">
        <v-row>
          <v-col cols="12">
            <v-card shaped class="pa-1">
              <v-card-title class="justify-center primary--text"
                >Description</v-card-title
              >
              <v-card-subtitle class="text-center">{{
                npc.Description
              }}</v-card-subtitle>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card shaped class="pa-1" v-if="npc.Abilities">
              <v-card-title class="justify-center primary--text"
                >Alignment</v-card-title
              >
              <v-row>
                <v-col cols="4">
                  <v-card-subtitle class="py-0 text-center"
                    >Good : {{ npc.Alignment.good }}</v-card-subtitle
                  >
                </v-col>
                <v-col cols="4">
                  <v-card-subtitle class="py-0 text-center"
                    >Moralne Neutral :
                    {{ npc.Alignment.moralneutral }}</v-card-subtitle
                  >
                </v-col>
                <v-col cols="4">
                  <v-card-subtitle class="py-0 text-center"
                    >Evil : {{ npc.Alignment.evil }}</v-card-subtitle
                  >
                </v-col>
                <v-col cols="4">
                  <v-card-subtitle class="py-0 text-center"
                    >Lawful : {{ npc.Alignment.lawful }}</v-card-subtitle
                  >
                </v-col>
                <v-col cols="4">
                  <v-card-subtitle class="py-0 text-center"
                    >Ethical Neutral :
                    {{ npc.Alignment.ethicalneutral }}</v-card-subtitle
                  >
                </v-col>
                <v-col cols="4">
                  <v-card-subtitle class="py-0 text-center"
                    >Chaotic : {{ npc.Alignment.chaotic }}</v-card-subtitle
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4">
        <v-row>
          <v-col cols="12">
            <v-card shaped>
              <v-card-title class="justify-center primary--text"
                >Dnd Beyond Link</v-card-title
              >
              <v-card-subtitle class="text-center">{{
                npc.DndBeyondLink
              }}</v-card-subtitle>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card shaped v-if="npc.Alignment">
              <v-card-title class="justify-center primary--text"
                >Abilities</v-card-title
              >
              <v-row>
                <v-col cols="4">
                  <v-card-subtitle class="py-0 text-center"
                    >Str : {{ npc.Abilities.str }}</v-card-subtitle
                  >
                </v-col>
                <v-col cols="4">
                  <v-card-subtitle class="py-0 text-center"
                    >Dex : {{ npc.Abilities.dex }}</v-card-subtitle
                  >
                </v-col>
                <v-col cols="4">
                  <v-card-subtitle class="py-0 text-center"
                    >Con : {{ npc.Abilities.con }}</v-card-subtitle
                  >
                </v-col>
                <v-col cols="4">
                  <v-card-subtitle class="py-0 text-center"
                    >Int : {{ npc.Abilities.int }}</v-card-subtitle
                  >
                </v-col>
                <v-col cols="4">
                  <v-card-subtitle class="py-0 text-center"
                    >Wis : {{ npc.Abilities.wis }}</v-card-subtitle
                  >
                </v-col>
                <v-col cols="4">
                  <v-card-subtitle class="py-0 text-center"
                    >Cha : {{ npc.Abilities.cha }}</v-card-subtitle
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card shaped v-if="npc.Occupation">
              <v-card-title class="justify-center primary--text"
                >Occupation</v-card-title
              >
              <v-card-subtitle class="text-center">{{
                npc.Occupation | capitalize
              }}</v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        <v-card shaped class="pa-1">
          <v-card-title class="justify-center primary--text"
            >Summary</v-card-title
          >
          <v-card-subtitle class="text-center">{{ npc.Notes }}</v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="12" md="12">
        <v-card shaped class="pa-1" v-if="npc.hook">
          <v-card-title class="justify-center primary--text"
            >Plot Hook Idea</v-card-title
          >
          <v-card-subtitle class="text-center">{{ npc.hook }}</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-card shaped v-if="showInventory">
      <v-card-title class="justify-center primary--text"
        >Inventory</v-card-title
      >
      <v-row class="px-2">
        <v-col cols="4">
          <v-card-subtitle class="pt-0 pb-0 secondary--text"
            >Inventory Name</v-card-subtitle
          >
        </v-col>
        <v-col cols="4">
          <v-card-subtitle class="pt-0 pb-0 secondary--text"
            >Type</v-card-subtitle
          >
        </v-col>
        <v-col cols="4">
          <v-card-subtitle class="pt-0 pb-0 secondary--text"
            >Description</v-card-subtitle
          >
        </v-col>
      </v-row>
      <v-row
        v-for="inventory in npc.Inventory"
        :key="inventory.name"
        class="px-2"
      >
        <v-col cols="4">
          <v-card-subtitle class="pt-0 pb-0">{{
            inventory.Name
          }}</v-card-subtitle>
        </v-col>
        <v-col cols="4">
          <v-card-subtitle class="pt-0 pb-0">{{
            inventory.Type
          }}</v-card-subtitle>
        </v-col>
        <v-col cols="4">
          <v-card-subtitle class="pt-0 pb-0">{{
            inventory.Description
          }}</v-card-subtitle>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="ma-2" flat>
      <v-row>
        <v-spacer></v-spacer>
        <v-card-title class="justify-center primary--text">Notes</v-card-title>
        <NewNote
          v-if="this.playerid === this.npc.PlayerId"
          :CreatedFrom="[npc.Name]"
        ></NewNote>
        <v-spacer></v-spacer>
      </v-row>
      <v-row justify="center">
        <v-hover v-for="note in notes" :key="note.id">
          <template v-slot:default="{ hover }">
            <v-card max-width="350" class="ma-4">
              <v-card-subtitle class="primary--text">{{
                note.Note | Trim
              }}</v-card-subtitle>
              <v-card-text>
                <v-chip-group>
                  <v-chip
                    class="my-0"
                    small
                    v-for="tag in note.tags"
                    :key="tag"
                    >{{ tag }}</v-chip
                  >
                </v-chip-group>
              </v-card-text>

              <v-fade-transition>
                <v-overlay v-if="hover" absolute color="#036358">
                  <v-btn
                    class="primary"
                    :to="{ name: 'EditNote', params: { id: note.id } }"
                    >See more info</v-btn
                  >
                </v-overlay>
              </v-fade-transition>
            </v-card>
          </template>
        </v-hover>
      </v-row>
    </v-card>

    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Delete {{ npc.Name }}?</v-card-title>
        <v-card-text
          >If you click Delete {{ npc.Name }} will be removed for
          ever.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="red darken-1" text @click="deleteNPC()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NewNote from "@/components/NewNote";

import db from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "NPC",
  components: { NewNote },
  methods: {
    EditNPC() {
      this.$router.push({
        name: "EditNPC",
        params: { id: this.$route.params.id },
      });
    },
    deleteNPC() {
      db.collection("npcs")
        .doc(this.$route.params.id)
        .delete()
        .then(
          this.$router.push({
            name: "NPCs",
          })
        );
    },
  },
  data() {
    return {
      npc: { Town: {}, Inventory: [] },
      Towns: [],
      playerid: null,
      deleteDialog: false,
      notes: [],
    };
  },
  computed: {
    showInventory() {
      if (this.npc.Inventory.length > 0) {
        return true;
      }
      return false;
      // }
    },
  },
  filters: {
    Trim: function(value) {
      if (!value) return "";
      if (value.length >= 50) return value.substring(0, 50) + "...";
      return value;
    },
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },

  firestore() {
    this.$bind("npc", db.collection("npcs").doc(this.$route.params.id)).then(
      (npc) => {
        if (this.playerid === npc.PlayerId) {
          db.collection("notes")
            .where("PlayerId", "==", firebase.auth().currentUser.uid)
            .where("tags", "array-contains", npc.Name)
            .get()
            .then((snapshot) => {
              snapshot.forEach((doc) => {
                this.notes.push({
                  ...doc.data(),
                  id: doc.id,
                });
              });
            });
        } else {
          db.collection("notes")
            .where("Public", "==", true)
            .where("tags", "array-contains", npc.Name)
            .get()
            .then((snapshot) => {
              snapshot.forEach((doc) => {
                this.notes.push({
                  ...doc.data(),
                  id: doc.id,
                });
              });
            });
        }
      }
    );
  },
  created() {
    firebase.auth().onAuthStateChanged((cred) => {
      this.playerid = cred.uid;
    });
  },
};
</script>
